(function () {
  'use strict';

  if (window.__amourCustomRingSizeReady) return;
  window.__amourCustomRingSizeReady = true;

  function normalized(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isMadeToOrder(value) {
    var candidate = normalized(value);
    return candidate.indexOf('custom size') !== -1 || candidate.indexOf('sondergröße') !== -1 || candidate.indexOf('other size') !== -1 || candidate.indexOf('cutom size') !== -1;
  }

  function selectedSize(form) {
    var master = form.querySelector('[data-ovale-size-select]');
    if (master) return master.value;

    var group = form.querySelector('[data-custom-ring-size-option-group]');
    if (!group) return '';
    var checked = group.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    var select = group.querySelector('[data-size-select]');
    return select ? select.value : '';
  }

  function setError(field, show) {
    var input = field.querySelector('[data-custom-ring-size-input]');
    var error = field.querySelector('[data-custom-ring-size-error]');
    if (!input) return;
    var message = input.dataset.errorMessage || '';
    input.setCustomValidity(show ? message : '');
    if (show) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
    if (error) error.hidden = !show;
  }

  function sync(form) {
    var field = form.querySelector('[data-custom-ring-size-field]');
    if (!field) return;
    var input = field.querySelector('[data-custom-ring-size-input]');
    var confirmLater = form.dataset.confirmSizeLater === 'true';
    var wasConfirmLater = input.dataset.confirmLaterActive === 'true';

    if (confirmLater) {
      if (!wasConfirmLater) input.dataset.manualValue = input.value;
      input.dataset.confirmLaterActive = 'true';
      input.value = input.dataset.confirmLaterValue || 'I will confirm the size later';
      field.hidden = true;
      input.disabled = false;
      input.required = false;
      var confirmSelect = form.querySelector('[data-custom-ring-size-option-group] [data-size-select]');
      if (confirmSelect && confirmSelect.querySelector('option[value="__confirm_size_later__"]')) confirmSelect.value = '__confirm_size_later__';
      setError(field, false);
      return;
    }

    if (wasConfirmLater) {
      input.value = input.dataset.manualValue || '';
      delete input.dataset.confirmLaterActive;
    }
    var active = isMadeToOrder(selectedSize(form));
    field.hidden = !active;
    input.disabled = !active;
    input.required = active;
    if (!active) setError(field, false);
  }

  function validate(form, focus) {
    var field = form.querySelector('[data-custom-ring-size-field]');
    if (!field || field.hidden) return true;
    var input = field.querySelector('[data-custom-ring-size-input]');
    input.value = input.value.trim();
    var valid = input.value.length > 0;
    setError(field, !valid);
    if (!valid && focus) input.focus();
    return valid;
  }

  function initForm(form) {
    var field = form.querySelector('[data-custom-ring-size-field]');
    if (!field) return;
    if (form.dataset.customRingSizeReady === 'true') {
      sync(form);
      return;
    }
    form.dataset.customRingSizeReady = 'true';
    var input = field.querySelector('[data-custom-ring-size-input]');
    var legacyGroup = form.querySelector('[data-custom-ring-size-option-group]');
    if (legacyGroup && legacyGroup.nextElementSibling !== field) legacyGroup.insertAdjacentElement('afterend', field);

    form.addEventListener('change', function (event) {
      var changed = event.target;
      var group = changed && changed.closest ? changed.closest('[data-custom-ring-size-option-group]') : null;
      if (group) {
        if (changed.matches('[data-size-select]') && changed.value === '__confirm_size_later__') {
          var selectedOption = changed.options[changed.selectedIndex];
          var selectedTarget = selectedOption && selectedOption.getAttribute('data-confirm-size-later-target');
          form.dataset.confirmSizeLater = 'true';
          form.dataset.confirmSizeLaterApplying = 'true';
          var selectedRadio = Array.prototype.find.call(group.querySelectorAll('input[type="radio"]'), function (radio) {
            return radio.value === selectedTarget && !radio.disabled;
          });
          if (selectedRadio) selectedRadio.click();
          delete form.dataset.confirmSizeLaterApplying;
          changed.value = selectedTarget;
          event.stopImmediatePropagation();
        } else if (form.dataset.confirmSizeLaterApplying !== 'true') {
          delete form.dataset.confirmSizeLater;
        }
      }
      window.setTimeout(function () { sync(form); }, 0);
    }, true);
    form.addEventListener('click', function (event) {
      var confirmControl = event.target.closest('[data-confirm-size-later-option]');
      var legacyConfirmButton = event.target.closest('[data-confirm-size-later-button]');
      if (confirmControl) {
        form.dataset.confirmSizeLater = 'true';
        if (legacyConfirmButton) {
          var targetValue = legacyConfirmButton.getAttribute('data-confirm-size-later-target');
          form.dataset.confirmSizeLaterApplying = 'true';
          var targetRadio = Array.prototype.find.call(form.querySelectorAll('[data-custom-ring-size-option-group] input[type="radio"]'), function (radio) {
            return radio.value === targetValue && !radio.disabled;
          });
          if (targetRadio) targetRadio.click();
          delete form.dataset.confirmSizeLaterApplying;
        }
        window.setTimeout(function () { sync(form); }, 0);
        return;
      }
      if (event.target.closest('[data-ovale-size-option], [data-custom-ring-size-option-group] label')) {
        delete form.dataset.confirmSizeLater;
        window.setTimeout(function () { sync(form); }, 0);
      }
    });
    input.addEventListener('input', function () {
      if (input.dataset.confirmLaterActive !== 'true') input.dataset.manualValue = input.value;
      if (input.value.trim()) setError(field, false);
    });
    input.addEventListener('blur', function () {
      if (!field.hidden) input.value = input.value.trim();
    });
    input.addEventListener('invalid', function (event) {
      event.preventDefault();
      setError(field, true);
      input.focus();
    });
    sync(form);
  }

  function initAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('form[action*="/cart/add"]'), initForm);
  }

  document.addEventListener('click', function (event) {
    var submitter = event.target.closest('button[type="submit"], input[type="submit"], [data-btn-addtocart], [data-btn-addToCart], [data-ovale-atc]');
    if (!submitter) return;
    var form = submitter.closest('form[action*="/cart/add"]');
    if (form && !validate(form, true)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (form && !validate(form, true)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('form[action*="/cart/add"]')) initForm(node);
            initAll(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  window.addEventListener('pageshow', function () { initAll(document); });
  window.addEventListener('popstate', function () {
    Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart/add"]'), sync);
  });
})();
